import type { Component } from "solid-js";
import { useAppUI } from "./AppUIContext";

export const LayoutControls: Component = () => {
  const { actions } = useAppUI();

  const toggleExtendedPane = () => {
    actions.toggleExtendedPane();
  };

  const toggleNavigation = () => {
    actions.toggleNavigationPane();
  };

  return (
    <div class="space-y-3">
      {/* Layout Controls */}
      <div class="bg-background dark:bg-dark-background border border-background-decoration dark:border-dark-background-decoration rounded-lg p-3 shadow-sm backdrop-blur-sm">
        <div class="flex items-center gap-2 mb-3">
          <svg
            class="w-4 h-4 text-primary dark:text-dark-primary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
            />
          </svg>
          <h4 class="text-sm font-medium text-on-background dark:text-dark-on-background">Layout</h4>
        </div>
        <div class="grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={toggleExtendedPane}
            class="px-3 py-2 text-xs bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary rounded-md hover:bg-primary-hover dark:hover:bg-dark-primary-hover transition-colors shadow-sm"
          >
            Side Panel
          </button>
          <button
            type="button"
            onClick={toggleNavigation}
            class="px-3 py-2 text-xs bg-surface dark:bg-dark-surface text-on-surface dark:text-dark-on-surface rounded-md hover:bg-surface-hover dark:hover:bg-dark-surface-hover transition-colors border border-surface-decoration dark:border-dark-surface-decoration"
          >
            Navigation
          </button>
          <button
            type="button"
            onClick={() => actions.setExtendedPanePosition("left")}
            class="px-3 py-2 text-xs bg-surface dark:bg-dark-surface text-on-surface dark:text-dark-on-surface rounded-md hover:bg-surface-hover dark:hover:bg-dark-surface-hover transition-colors border border-surface-decoration dark:border-dark-surface-decoration"
          >
            Panel ←
          </button>
          <button
            type="button"
            onClick={() => actions.setExtendedPanePosition("right")}
            class="px-3 py-2 text-xs bg-surface dark:bg-dark-surface text-on-surface dark:text-dark-on-surface rounded-md hover:bg-surface-hover dark:hover:bg-dark-surface-hover transition-colors border border-surface-decoration dark:border-dark-surface-decoration"
          >
            Panel →
          </button>
        </div>
      </div>

      {/* Quick Help */}
      <div class="bg-background dark:bg-dark-background border border-background-decoration dark:border-dark-background-decoration rounded-lg p-3 shadow-sm backdrop-blur-sm">
        <div class="flex items-center gap-2 mb-2">
          <svg
            class="w-3 h-3 text-on-background-variant dark:text-dark-on-background-variant"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span class="text-xs font-medium text-on-background-variant dark:text-dark-on-background-variant">
            Quick Help
          </span>
        </div>
        <div class="space-y-1 text-xs text-on-background-variant dark:text-dark-on-background-variant">
          <div>• Hover left edge to show navigation</div>
          <div>• Drag edges to resize panels</div>
          <div>• Use buttons above to control layout</div>
        </div>
      </div>
    </div>
  );
};
